import "./Profile.css";

const Profile = () => {
  const user = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <div className="profile-container">
      <h2>My Profile</h2>
      <div className="profile-card">
        <div>
          <strong>Name:</strong> {user?.user?.name}
        </div>
        <div>
          <strong>Email:</strong> {user?.user?.email}
        </div>
        <div>
          <strong>Phone:</strong> {user?.user?.phone}
        </div>
        <div>
          <strong>Address:</strong> {user?.user?.address}
        </div>
        <div>
          <strong>Member Since:</strong>{" "}
          {user?.user?.createdAt?.slice(0, 10) || "N/A"}
        </div>
      </div>
    </div>
  );
};

export default Profile;
